import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { BaseEntityContainerStore, BaseEntityStore, BaseEntityTabsStore } from '@processpuzzle/base-entity';
import { ApplicationProperty } from '@processpuzzle/base-widget';
import { BizApplicationPropertyService } from './biz-application-property.service';

/**
 * The same store core's `ApplicationPropertyStore` is, pointed at {@link BizApplicationPropertyService}.
 *
 * It is a separate store rather than a configuration of core's because core's is built around
 * `ApplicationPropertyService`, which is not exported and resolves `THIRD_PARTY_ROOT` — see the
 * service for why that is wrong here. `app.config.ts` binds *this* class to core's
 * `ApplicationPropertyStore` **token**, which is what `LikeButtonComponent` injects, so the widget
 * needs no change and core needs no release.
 *
 * **No `{ providedIn: 'root' }`**, unlike core's. This store exists only where `app.config.ts`
 * provides it, and a tree-shakable root provider here would be a second, competing answer to the
 * same question — the explicit provider would win, but which one is winning would stop being
 * visible at the call site.
 */
export const BizApplicationPropertyStore = signalStore(
  BaseEntityStore<ApplicationProperty>(ApplicationProperty, () => inject(BizApplicationPropertyService)),
  BaseEntityTabsStore(),
  BaseEntityContainerStore(),
  withDevtools('BizApplicationProperty'),
);
